<template>
  <button class="btn btn-primary" @click="update" :disabled="updating">
    {{ $t('external_pos.refresh_pos_inventory') }}
  </button>
</template>

<script>
import ExternalInventoryUpdaterFile from "@/components/inventory/ExternalInventoryUpdaterMaitreDFile";
import {Core} from "@/core/Core";

export default {
  name: "ExternalInventoryUpdater",
  components: {ExternalInventoryUpdaterFile},
  props: {
    inventory: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      updating: false
    }
  },

  methods: {
    async update(body = {}) {
      this.updating = true;
      try {
        let response = await Core.request('POST', `/api/inventory/${this.inventory}/external_items_refresh`, body);
        if (response) {
          let updateMsg = this.$t('external_pos.inventory_updated');
          if (response.warnings && response.warnings.length > 0) {
            let warnMessages = response.warnings.map(w => this.$to(w.msg));
            if (response.warnings.some(w => w.key && w.key.includes('not_mapped'))) {
              warnMessages.push(this.$t('external_pos.warning_pos_configuration'));
            }
            toast(warnMessages.join('<br>'), 'warning', updateMsg, 20);
          } else {
            toast(updateMsg, 'success');
          }
        }
      } catch (e) {
        let asJson = window.tryParseAsJson(e.response);
        if (asJson && asJson.key === 'reception_offline') {
          this.manualFileModal()
        } else {
          Core.showRequestExceptionAsToast(e)
        }
      }
      this.updating = false;
    },

    manualFileModal() {
      this.$store.state.modalComponent = ExternalInventoryUpdaterFile
      this.$store.state.modalProps = { width: 600 }
      this.$store.state.modalComponentProps = {
        fileCallback: this.onFileUploaded
      }
      this.$modal.show('component-modal');
    },

    async onFileUploaded(file) {
      this.$modal.hide('component-modal');
      await this.update({via: 'file', file});
    }
  }
}
</script>

<style lang="scss" scoped>

</style>